import { isValidElement, ReactNode } from 'react'

import { reactToString } from './reactToString'

interface ShouldDisplayParams {
  label: ReactNode
  keyword: string
}

export const shouldDisplay = ({ label, keyword }: ShouldDisplayParams) => {
  if (!keyword.trim()) {
    return true
  }

  const lowerKeyword = keyword.toLocaleLowerCase()

  if (typeof label === 'string' || typeof label === 'number') {
    return `${label}`.toLocaleLowerCase().includes(lowerKeyword)
  }

  if (isValidElement<{ children?: ReactNode }>(label)) {
    return reactToString(label).join('').toLocaleLowerCase().includes(lowerKeyword)
  }

  return false
}
